import {DepositItem} from 'app/blocks/model/deposit-item.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import {IDepositItem} from 'app/blocks/model/deposit-item.model';
import EntityCrudService from 'app/blocks/service/api/entity-service';

@Injectable({
    providedIn: 'root'
})
export class DepositItemService extends EntityCrudService<IDepositItem> {
    constructor(http: HttpClient) {
        super(http, Resource.DEPOSIT_ITEMS, (obj?) => new DepositItem(obj));
    }
}
